/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import storageService from '@/lib/storage-service';
import { API_BASE_URL } from '@/constants/api-endpoints.constants';

export async function getSearchSuggestion(query: any) {
    const data = await axios.post(`${API_BASE_URL}/search/${import.meta.env.VITE_ELASTICSEARCH_URL}-resource-auditevent/_search`, 
        query,
        { 
            headers:  { Authorization: `Bearer ${storageService.getAccessToken()}`}
        }
        );
    return data || [];
}

export async function getLonicSuggestion(query: any) {
    const data = await axios.post(`${API_BASE_URL}/search/loinc-v1/_search`, 
        query,
        { 
            headers:  { Authorization: `Bearer ${storageService.getAccessToken()}`}
        }
        );
    return data || [];
}
